import styled, { css } from 'styled-components'
import theme from 'theme_'

export const NetworkClientListFrame = styled.div`
  display: flex;
  gap: ${theme.spacing.base};
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  width: 100%;
  height: 800px;

  overflow-x: hidden; /* Hide horizontal scrollbar */
  overflow-y: scroll; /* Add vertical scrollbar */

  flex: none;
  order: 1;
  flex-grow: 1;

  @media ${theme.devices.mobile} {
    gap: ${theme.spacing.xs};
  }
`

export const NetworkClientListContentFrame = styled.div`
  /* Frame 626110 */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 32px;
  gap: 16px;

  max-width: 1300px;
  height: 848px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.mobile} {
    gap: ${theme.spacing.xs};
  }
`

export const NetworkClientListInfoFrame = styled.div`
  /* Frame 37 */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;

  height: 104px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.mobile} {
    height: 450px;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${theme.spacing.xs};
  }
`

export const NetworkClientListInnerBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 8px;

  width: 10%;
  height: 104px;

  background: #ffffff;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;

  flex: none;
  flex-grow: 1;

  @media ${theme.devices.mobile} {
    width: 48%;
  }
`

export const NetworkClientListBoxHeaderInner = styled.div`
  /* Frame 34 */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  max-width: 110.43px;
  height: 19px;

  flex: none;
  order: 0;
  flex-grow: 1;
`

export const NetworkClientListBoxHeaderFont = styled.span`
  width: 100px;
  height: 19px;
  font-style: normal;
  font-weight: 450;
  font-size: 16px;
  line-height: 19px;
  color: ${theme.colors.otterWarmBlack};
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.tablet} {
    font-size: 12px;
    width: 60px;
  }

  @media ${theme.devices.mediumDesktop} {
    font-size: 14px;
    width: 100px;
  }
`

export const NetworkClientListBoxDetails = styled.div`
  /* Frame 34 */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 0px 0px;
  gap: 15px;

  width: 140.43px;
  height: 33px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;

  @media ${theme.devices.mobile} {
    text-align: center;
  }
`

export const NetworkClientListBoxDetailsFont = styled.div`
  /* text */

  width: 40px;
  height: 38px;

  font-style: normal;
  font-weight: 900;
  font-size: 32px;
  line-height: 38px;

  color: ${theme.colors.otterWarmBlack};

  flex: none;
  order: 0;
  flex-grow: 0;
`

export const NetworkClientListListFrame = styled.div`
  /* Frame 36 */

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0px 0px 0px;

  width: 100%;
  height: 624px;

  border-radius: 8px;

  flex: none;
  order: 4;
  align-self: stretch;
  flex-grow: 0;
`

export const NetworkClientListClientListHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 24px 0px 16px;
  gap: 12px;
  width: 100%;
  height: 50px;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.tabletMidLandscape} {
    font-size: 10px;
  }
`

export const NetworkClientListHeaderText = styled.span`
  width: 42px;
  height: 24px;
  font-style: normal;
  font-weight: 350;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.otterWarmBlack};
  flex: none;
  order: 0;
  flex-grow: 0;

  @media ${theme.devices.tabletMidLandscape} {
    font-size: 12px;
  }

  @media ${theme.devices.mediumDesktop} {
    font-size: 14px;
  }
`

export const NetworkClientListHeaderTextBase = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0px;
  width: 100%;
  white-space: nowrap;
  align-items: left;
  gap: ${theme.spacing.tiny};
  height: 24px;
  width: 100%;
`

export const NetworkClientListHeaderTextFrameName = styled.div`
  ${NetworkClientListHeaderTextBase};
`

export const NetworkClientListHeaderTextFrameMac = styled.div`
  ${NetworkClientListHeaderTextBase};
  min-width: 130px;
`

export const NetworkClientListHeaderTextFrameIP = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 80px;
  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const NetworkClientListHeaderTextFrameDevice = styled.div`
  ${NetworkClientListHeaderTextBase};
  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const NetworkClientListHeaderTextFrameProtocol = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 60px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameBand = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 60px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameSSID = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 90px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameBytes = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 80px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameConnected = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 70px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientmobile = styled.div`
  display: none;
  @media ${theme.devices.mobile} {
    display: flex;
  }
`
export const NetworkClienttablet = styled.div`
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`
export const NetworkClienttabletMid = styled.div`
  display: none;
  @media ${theme.devices.tabletMid} {
    display: flex;
  }
`
export const NetworkClienttabletLandscape = styled.div`
  display: none;
  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }
`
export const NetworkClienttabletMidLandscape = styled.div`
  display: none;
  @media ${theme.devices.tabletMidLandscape} {
    display: flex;
  }
`
export const NetworkClientdesktop = styled.div`
  display: none;
  @media ${theme.devices.desktop} {
    display: flex;
  }
`
export const NetworkClientmediumDesktop = styled.div`
  display: none;
  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`
